<template>
    <BasicMenu
        ref="basicMenu"
        :items="items"
        :show="show"
        placement="bottom-end"
        offset-distance="5"
        :interactive="false"
        @click:item="handleClickMenuItem"
        @close:manual="emits('close:manual')"
        v-on="dynamicBasicMenuListeners"
    >
        <template #activator>
            <UserAvatar
                id="user-avatar"
                class="cursor-pointer"
                v-on="dynamicUserAvatarListeners"
            />
        </template>
        <template #outter:avatar="{ name }">
            <BasicMenuListItem
                :name="name"
                :hoverable="false"
                data-testid="user-info-avatar-menu"
            >
                <template #wrapper>
                    <UserAvatar
                        :size="maxSm ? '70' : '54'"
                        class="mr-[15px]"
                        :hover="false"
                    />
                    <div
                        class="text-[21px] leading-7 overflow-hidden break-words"
                    >
                        {{ nickname }}
                    </div>
                </template>
            </BasicMenuListItem>
        </template>
    </BasicMenu>
</template>

<script lang="ts" setup>
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

import UserAvatar from '@atoms/UserAvatar/UserAvatar.vue';
import BasicMenu, {
    type BasicMenuEmits,
} from '@molecules/BasicMenu/BasicMenu.vue';
import BasicMenuListItem, {
    type BasicMenuListItemProps,
} from '@molecules/BasicMenu/BasicMenuListItem.vue';

export type UserMenuProps = {
    items: BasicMenuListItemProps[];
    show?: boolean;
    nickname: string;
};

const basicMenu = ref(null);

const breakpoints = useBreakpoints(breakpointsTailwind);
const maxSm = breakpoints.smallerOrEqual('sm');

const emits = defineEmits<BasicMenuEmits>();

const props = withDefaults(defineProps<UserMenuProps>(), {
    show: undefined,
});

onClickOutside(basicMenu, () => emits('close:popper'));

const handleClickMenuItem = ($event: string) => {
    emits('click:item', $event);
    emits('close:popper');
};

const handleUserAvatarClick = () => {
    props.show ? emits('close:popper') : emits('open:popper');
};

const dynamicBasicMenuListeners = computed(() => {
    return {
        'open:popper':
            props.show === undefined ? emits('open:popper') : undefined,
        'close:popper':
            props.show === undefined ? emits('close:popper') : undefined,
    };
});

const dynamicUserAvatarListeners = computed(() => {
    return {
        click: props.show === undefined ? undefined : handleUserAvatarClick,
    };
});
</script>
